/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

const { LogLevel } = require("@azure/msal-browser")

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
const msalConfig = {
  auth: {
    // clientId: "7bd4a9fb-c094-4f4a-a72b-ea2b85da9826",
    // clientId: "09db444d-7c87-4dc6-8c7d-459b70fd5218",
    clientId: "faef7d60-70eb-4640-b273-b98c6b618196",
    // clientId: "ffe63e77-62c4-42f7-a963-a6c8ce80db7b",
    authority:
      "https://login.microsoftonline.com/71cd2a1f-2535-40dd-8200-13a34242985e/",
    // redirectUri: "https://af6b24161a39.ngrok.io"
    // redirectUri: "https://27ed78f28579.ngrok.io"
    clientSecret: "B13mvC8_yHxmpKj7i-C0-f5F_2Aa5FELe."
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message)
            return
          case LogLevel.Info:
            console.info(message)
            return
          case LogLevel.Verbose:
            console.debug(message)
            return
          case LogLevel.Warning:
            console.warn(message)
            return
          default:
            return
        }
      }
    }
  }
}

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: ["files.readwrite.all", "offline_access"]
}

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
  graphMeEndpoint:
    "https://graph.microsoft.com/v1.0/users/f1e62031-dd1b-470f-b585-e4f81289c65c",
  graphDataEndpoint:
    "https://graph.microsoft.com/v1.0/users/f1e62031-dd1b-470f-b585-e4f81289c65c/drive/root:/meetyou.xlsx:/workbook/worksheets/Sheet1/usedRange",
  graphDataEndpointRange: (start, end) =>
    `https://graph.microsoft.com/v1.0/users/f1e62031-dd1b-470f-b585-e4f81289c65c/drive/root:/meetyou.xlsx:/workbook/worksheets/Sheet1/range(address='${start}:${end}')`,
  graphPatchEndpoint: (start, end) =>
    `https://graph.microsoft.com/v1.0/users/f1e62031-dd1b-470f-b585-e4f81289c65c/drive/root:/meetyou.xlsx:/workbook/worksheets/Sheet1/range(address='${start}:${end}')`
}

export default msalConfig
